var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card shadow-sm" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            _vm._l(_vm.questions, function(question) {
              return _c("div", { staticClass: "mb-5" }, [
                _c("h5", { staticClass: "card-title" }, [
                  _vm._v(
                    "\n                            " +
                      _vm._s(question.title) +
                      "\n                        "
                  )
                ]),
                _vm._v(" "),
                _c("div", { domProps: { innerHTML: _vm._s(question.text) } }),
                _vm._v(" "),
                question.image_url !== null
                  ? _c("div", { staticClass: "mt-2" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        staticStyle: { "max-height": "300px" },
                        attrs: { src: question.image_url, alt: question.title }
                      })
                    ])
                  : _vm._e()
              ])
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.questions.length
        ? _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "alert alert-secondary border-dark" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("pages.faq.none")) +
                  "\n            "
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }